












import { Component, Prop, Vue } from 'vue-property-decorator';

@Component
export default class TaftUserInitials extends Vue {
  @Prop(String)
    name!: string;
  @Prop(Number)
    size!: number;
  @Prop(Boolean)
    isDeleted!: boolean;
  @Prop({ type: String, default: 'dark' })
    theme!: string; // light, dark

  get initials(): string {
    const names: string[] = this.$props.name.split(' ');

    return (names.length === 1
      ? names[0].substring(0, 1)
      : `${names[0].substring(0, 1)}${names[names.length - 1].substring(0, 1)}`)
      .toUpperCase();
  }
}
